import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import tajweedImg from '../../images/service/service/Tajweed.webp'
import tajweedRules from '../../images/service/service-sub-pages/Tajweed.jpg'
import banner2 from '../../images/banners/2.webp'
import './style.css'

const Tajweed = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Tajweed'} pagesub={'Service'} backgroundImage={banner2} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={tajweedImg} alt="Tajweed - Quran Recitation Rules"/>
                                </div>
                                <h2 className="service-title"> <span>Tajweed</span> <br/> (Quran Recitation Rules)</h2>
                                <div className="service-description">
                                    <p>Master the art of beautiful Quran recitation with our comprehensive Tajweed course. Designed for students who already know the Arabic letters and can read basic text, this program focuses on teaching the correct pronunciation rules that enhance the beauty and accuracy of Quranic recitation.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={tajweedRules} alt="Tajweed Rules Illustration"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-book"></i> Course Content</h3>
                                        <ul className="service-features-list">
                                            <li>Pronunciations - mastering correct articulation of Arabic letters</li>
                                            <li>Rules of reading Quran - comprehensive coverage of Tajweed principles</li>
                                            <li>Recitation - practical application through guided reading</li>
                                            <li>Analysis of student's Tajweed - personalized feedback and correction</li>
                                            <li>Articulation points (Makhaarij) - learning exactly where each letter should be pronounced from</li>
                                            <li>Characteristics of letters (Sifaat) - understanding the unique qualities of each Arabic letter</li>
                                            <li>Rules of Noon and Meem Saakinah - mastering key pronunciation rules</li>
                                            <li>Rules of Madd (prolongation) - learning when and how to extend sounds</li>
                                            <li>Stopping rules (Waqf) - understanding proper pausing techniques</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-teacher"></i> Course Format</h3>
                                    <div className="service-section-content">
                                        <p>Our Tajweed program is available as both one-to-one tutoring and small group classes. We emphasize practical application with extensive recitation practice and individualized correction. Each student receives personalized attention to ensure proper technique development.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-calendar"></i> Schedule Flexibility</h3>
                                    <div className="service-section-content">
                                        <p>We offer adaptable scheduling to accommodate your needs:</p>
                                        <ul className="service-features-list">
                                            <li>Weekly lessons</li>
                                            <li>Multiple sessions</li>
                                            <li>Flexible timing options including evenings and weekends</li>
                                            <li>Consistent schedule to build regular practice habits</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-money-bag"></i> Course Fees</h3>
                                    <div className="service-section-content">
                                        <div className="pricing-table">
                                            <div className="pricing-option">
                                                <h4>3 Days per Week</h4>
                                                <div className="price">£30<span>/month</span></div>
                                                <p>Ideal for regular practice with balanced commitment</p>
                                            </div>
                                            <div className="pricing-option featured">
                                                <h4>4 Days per Week</h4>
                                                <div className="price">£40<span>/month</span></div>
                                                <p>Recommended for steady progress</p>
                                            </div>
                                            <div className="pricing-option">
                                                <h4>5 Days per Week</h4>
                                                <div className="price">£50<span>/month</span></div>
                                                <p>Intensive learning for rapid improvement</p>
                                            </div>
                                        </div>
                                        <p className="pricing-note">All packages include expert instruction, personalized feedback, and access to learning materials. Family discounts available for multiple enrollments.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-lotus"></i> Benefits of Our Tajweed Course</h3>
                                    <div className="service-section-content">
                                        <ul className="service-features-list">
                                            <li>Develop clear, confident recitation that follows authentic Quranic traditions</li>
                                            <li>Gain a deeper understanding of Arabic phonetics and pronunciation</li>
                                            <li>Receive detailed personal feedback on each aspect of your recitation</li>
                                            <li>Progress through a structured curriculum with clear milestones</li>
                                            <li>Build the foundation for more advanced recitation studies</li>
                                            <li>Appreciate the beauty of the Quran's rhythmic patterns</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>Our Tajweed course transforms basic reading into beautiful recitation. Through methodical instruction and patient guidance, students develop the confidence to recite the Quran correctly, following the same principles that have preserved its oral tradition for generations. Our skilled teachers provide consistent feedback, helping you refine your pronunciation until each rule becomes second nature.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book a Free Trial Class</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/basic-qaida">Previous: Basic Qaida</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/tajweed-improvement">Next: Tajweed Improvement</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li className="current"><Link to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Book Your Free Trial Class</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default Tajweed; 